module.exports = __webpack_public_path__ + "img/reservation.563ab402.png";